<template>
  <div class="nav"
       :style="{ background: background_color }">
    <div class="nav-tt">
      <div @click="clickOn()"
           class="nav-img">
        <img :src="logo" />
      </div>
      <div class="nav-tt-qycg">
        <ul>
          <li v-if="admin == 1"
              :class="{ active: isActive == 1 }"
              @click="myOrder(1)">
            统计分析
          </li>
          <li v-if="admin == 0"
              :class="{ active: isActive == 2 }"
              @click="myOrder(2)">
            订单中心
          </li>

          <!-- <li :class="{active:isActive==3}"
              @click="myOrder(3)"
              v-show="this.level != 2">组织架构</li> -->
          <!-- <li :class="{active:isActive==4}" @click="myOrder(4)" v-show="this.level == 0">审核设置</li> -->
          <li v-if="admin == 1"
              :class="{ active: isActive == 5 }"
              @click="myOrder(5)">
            活动管理
          </li>
          <li v-if="admin == 1"
              :class="{ active: isActive == 6 }"
              @click="myOrder(6)">
            发票管理
          </li>
          <li v-if="admin == 1"
              :class="{ active: isActive == 7 }"
              @click="myOrder(7)">
            对账管理
          </li>
        </ul>
        <div class="btn"
             v-if="admin == 0"
             @click="clickOn()">返回卖场</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  inject: ['reload'],
  data() {
    return {
      isActive: 0,
      logo: '',
      route_url: this.$route.params.route_url,
      logo: this.$store.state.qycg_user.basics.logo,
      background_color: this.$store.state.qycg_user.basics.colour,
      admin: this.$store.state.qycg_user.is_admin
    }
  },
  created() {
    // this.setColor()
    // console.log(this.$store.state)
  },
  mounted() {
    if (this.$route.query.item) {
      this.isActive = this.$route.query.item
    } else {
      this.isActive = 0
    }
  },
  methods: {
    myOrder(i) {
      this.isActive = i
      if (this.$route.query.item == i) {
        this.reload()
        return false
      }
      if (i == 1) {
        this.$router.replace({
          path: this.common.qycgrouter(this) + '/personal',
          query: {
            item: i
          }
        })
      } else if (i == 2) {
        this.$router.replace({
          path: this.common.qycgrouter(this) + '/ordercenter',
          query: {
            item: i
          }
        })
      } else if (i == 3) {
        this.$router.replace({
          path: this.common.qycgrouter(this) + '/framework',
          query: {
            item: i
          }
        })
      } else if (i == 4) {
        this.$router.replace({
          path: this.common.qycgrouter(this) + '/purchase',
          query: {
            item: i
          }
        })
      } else if (i == 5) {
        this.$router.replace({
          path: this.common.qycgrouter(this) + '/activities',
          query: {
            item: i
          }
        })
      } else if (i == 6) {
        this.$router.replace({
          path: this.common.qycgrouter(this) + '/invoiceInformation',
          query: {
            item: i
          }
        })
      }else if (i == 7) {
        this.$router.replace({
          path: this.common.qycgrouter(this) + '/reconciliation',
          query: {
            item: i
          }
        })
      }
    },
    clickOn() {
      if (this.admin == 0) {
        this.$router.push(this.common.qycgrouter(this) + '/qycgindex')
      } else {
        this.$router.push(this.common.qycgrouter(this) + '/personal')
      }
      // console.log(this.common.qycgrouter(this))
    }
  }
}
</script>

<style lang="scss" scoped>
.nav {
  width: 100%;
  height: 64px;

  // background: linear-gradient(270deg, #FF0E25 0%, #FF9010 100%);
  .nav-tt {
    width: 1080px;
    height: 64px;
    margin: 0 auto;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .nav-img {
      width: 180px;
      height: 50px;
      cursor: pointer;

      img {
        width: 180px;
        height: 50px;
      }
    }

    .nav-tt-qycg {
      width: 940px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      ul {
        display: flex;
        height: 64px;
        align-items: center;

        li {
          width: 56px;
          height: 64px;
          margin-left: 48px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333;
          line-height: 68px;
          cursor: pointer;
          border-bottom: 5px solid transparent;
        }

        .active {
          // border-bottom: 5px solid #ffffff;
          border-bottom: 5px solid #ff0e25;
        }
      }

      .btn {
        width: 80px;
        height: 28px;
        border-radius: 14px;
        border: 1px solid #333;
        line-height: 28px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333;
        text-align: center;
        margin-left: 258px;
        cursor: pointer;
      }
    }
  }
}
</style>
